export const getOptimizelyAbTrackingString = () => {
    const getActiveExperiments = () => {
        return window && window.optimizelyEdgeStst?.activeExperiments;
    };
    const tests = getActiveExperiments();
    if (!tests)
        return '';
    const experimentsText = Object.values(tests)
        .map((experiment) => experiment?.variation?.name + '_' + experiment?.name)
        .join(',');
    return experimentsText;
};
//# sourceMappingURL=optimizelyTrackingString.js.map